import { ActionTree } from 'vuex';
import { IEngagementVideo } from '../types/engagement-video';
import { IEngagementVideoState } from './engagement-video.types';
import {
  EEngagementVideoAction,
  EEngagementVideoMutation,
  state as defaultState,
} from './engagement-video.constants';
import { RootState } from '@/store/store';
import { VideoService } from '@/api/video/services/video.service';
import { IVideo } from '@/types/Video';
import { translate } from '@/helpers/translation.helper';

export const actions: ActionTree<IEngagementVideoState, RootState> = {
  [EEngagementVideoAction.Reset]({ commit }) {
    commit(EEngagementVideoMutation.SetState, { ...defaultState });
  },
  async [EEngagementVideoAction.Add](
    { commit, dispatch },
    { documentId, videoId }: { documentId: string; videoId: string }
  ) {
    commit(EEngagementVideoMutation.SetAdding, true);
    try {
      const success: boolean = await VideoService.addEngageVideo(videoId, documentId);
      if (!success) {
        dispatch(EEngagementVideoAction.AddFailed);
        return;
      }
      const video: IVideo = await VideoService.loadEngageVideo(documentId);
      const engagementVideo: IEngagementVideo = {
        id: video.id,
        video,
      };
      dispatch(EEngagementVideoAction.AddSuccess, engagementVideo);
    } catch (e) {
      dispatch(EEngagementVideoAction.AddFailed);
    }
  },
  [EEngagementVideoAction.AddFailed]({ dispatch }) {
    dispatch('alert/showDangerAlert', translate('could-not-add-engagement-video').toString(), {
      root: true,
    });
  },
  [EEngagementVideoAction.AddSuccess]({ commit }, video: IEngagementVideo) {
    commit(EEngagementVideoMutation.SetVideo, video);
    commit(EEngagementVideoMutation.SetAdding, false);
  },
};
